// Admin Dashboard shared context — gives every tab access to the full state bag
// owned by AdminDashboard without prop drilling.
import { createContext, useContext } from 'react';

export const AdminDashboardContext = createContext(null);

export function useAdminCtx() {
  const ctx = useContext(AdminDashboardContext);
  if (!ctx) {
    throw new Error('useAdminCtx must be used inside <AdminDashboardContext.Provider>');
  }
  return ctx;
}
